import { Component, HostListener, Input, OnInit, SimpleChanges } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SwiperConfigInterface } from 'ngx-swiper-wrapper';
import { environment } from "src/environments/environment";
import { ProductService } from '../../shared/services/product.service';
import { SideBarSummaryCartComponent } from '../../shared/sidebar-summary-cart/sidebar-summary-cart.component';
import { SideNavBarService } from '../../shared/services/sidenavbar.service';
import { Cart1Service } from '../../shared/services/cart1.service';
import { ConfigService } from '../../shared/services/config.service';
import { AutoshipConfigurationService } from '../../shared/services/autoshipConfiguration.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-autoship-detail-page',
  templateUrl: './autoship-detail-page.component.html',
  styleUrls: ['./autoship-detail-page.component.scss']
})

export class AutoshipDetailPageComponent implements OnInit {
  productdetails:any;
    product:any;
    env: any;
    isVideoModalOpen = false;
    showProducts:boolean;
    _screenSize:any;
    public config: SwiperConfigInterface = {};
     @Input() displayProducts = [
      {
        img: "../../../../assets/images/productRating/product1.png",
        startext:
          "Sometime Change is necessary and I Found mine here.",
        author: "DR. JACOB",
        type: "Customer",
        small: true,
        medium: false,
        left: false,
        leftbig: false,
        boxTitle: 'COMMON SENSE',
        boxContent: 'Loyalty Rewards Program'
      },
      {
        img: "../../../../assets/images/productRating/product2.png",
        startext:
          "I thank God I found a company that cares more about it's distributor's and customers than it does about itself.",
        author: "PAULA WANGNER",
        type: "Customer",
        small: true,
        medium: false,
        left: false,
        leftbig: false,
        boxTitle: 'COMMON SENSE',
        boxContent: 'Loyalty Rewards Program'
      },
      {
        img: "../../../../assets/images/productRating/product3.png",
        startext:
          "Super products, especially now when we need to keep our immune system strong!",
        author: "DR. KARL ANDERSON",
        type: "BrainSense",
        small: true,
        medium: false,
        left: false,
        leftbig: false,
        boxTitle: 'COMMON SENSE',
        boxContent: 'Loyalty Rewards Program'
      },
      {
        img: "../../../../assets/images/productRating/product1.png",
        startext:
          "This is the best tasting mangosteen drink I have tried. I crave it everyday.",
        author: "ROBIN",
        type: "Customer",
        small: true,
        medium: false,
        left: false,
        leftbig: false,
        boxTitle: 'COMMON SENSE',
        boxContent: 'Loyalty Rewards Program'
      },
     ];
     testimonialImageUrl = '../../../../assets/images/new/BrainSenseNEW.webp';
     ItemCode:any
     public shipMethod:any="subscribe";
     autoshipFreq:any;
    public commonData: any;
    constructor(
      private productservice: ProductService,
      private router: Router,
      private activateroute: ActivatedRoute,
      private SideNavBarService:SideNavBarService,
      private cartservice:Cart1Service,
      public configService: ConfigService,
      public autoshipConfigurationService: AutoshipConfigurationService,
      private sanitizer: DomSanitizer
    ) { 
      this.commonData = this.configService.getConfig();
      if (this.shipMethod === 'subscribe') {
        this.autoshipFreq = this.commonData.FrequencyTypes[0]?.ID; 
      }
    }
  
    splitText: string[] = [];
    plainText: string = '';
    convertToPlainText(html: string): string {
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = html;
      return tempDiv.textContent || tempDiv.innerText || '';
    }
  
    // Function to split the plain text at the specified word
    splitByWord(text: string, word: string): string[] {
      const regex = new RegExp(`(${word})`, 'i'); // Keeps the matched word in case you want to use it later
      const parts = text?.split(regex);
    
      if (parts.length > 1) {
        return [parts[0].trim(), parts.slice(1).join('').trim()];
      } else {
        return [text]; // If word not found, return whole text as the first part
      }
    }
    productDiscription:any;
    productSuggestions:any;
    productImages:any;
    Specifications: any;
    safeProductDescription: SafeHtml;
    ngOnInit(): void {
    // this.SideNavBarService.openSidePanel();
    this.env = environment;
    window.scrollTo(0, 0);
    this.autoshipConfigurationService.init();
  
  
    this.activateroute.queryParamMap.subscribe((params) => {
      const productId = params.get('id');  // Get the parameter from URL
      // const idMatch = productId?.match(/-id(.+)/);
      if (productId && productId.includes('-id')) {
        const parts = productId.split('-id');
        this.ItemCode = parts[1];  // Convert to number
        if(this.ItemCode){
          this.productservice.getProduct(this.ItemCode).subscribe(data => {
            this.productdetails = data;
            this.product = this.productdetails;
            this.Specifications = this.product?.Specifications;
            this.splitText = this.splitByWord(this.product?.Description, 'SUGGESTED Use:');
            this.productDiscription = this.splitText[0];
            this.safeProductDescription = this.sanitizer.bypassSecurityTrustHtml(
              this.transformDescription(this.productDiscription)
            );
            this.productSuggestions=this.splitText[1];
            if(this.product.Images[1]){
              this.productImages=this.product.Images[1].Path;
            }else{
              this.productImages='';
            }
          })
        }
      }
      // this.ItemCode = params.get('id'); 
    });
  
      this._screenSize=window.innerWidth
      if(this.displayProducts.length <= 1){
        this.showProducts = true;
      }else{
        this.showProducts=true;
      }
    }
    @HostListener('window:resize', ['$event'])
    onWindowResize(event: Event) {
      this.windowResize(event);
    }
    windowResize(event: Event): void {
      this._screenSize=window.innerWidth
      if(this._screenSize<=975) {
  
      }
    }
    transformDescription(html: string): string {
      const div = document.createElement('div');
      div.innerHTML = html;
    
      const anchors = div.querySelectorAll('a');
      anchors.forEach(a => {
        const href = a.getAttribute('href');
    
        if (!href || href.trim() === '') {
          // No href or empty href — convert to plain text
          const text = document.createTextNode(a.textContent || '');
          a.replaceWith(text);
        } else {
          // Optional: sanitize or force href to open in new tab
          a.setAttribute('target', '_blank');
          a.setAttribute('rel', 'noopener');
        }
      });
    
      return div.innerHTML;
    }
    
    ngAfterViewInit(): void {
      this._screenSize=window.innerWidth
      this.config = {
        mousewheel:false,
        observer: true,
        slidesPerView: 1,
        spaceBetween: 10,
        keyboard: true,
        navigation: true,
        pagination: false,
        grabCursor: true,
        loop: true,
        preloadImages: true,
        //lazy: true,
        breakpoints: {
          480: {
            slidesPerView: 1,
          },
          768: {
            slidesPerView: 2,
          },
          1025: {
            slidesPerView: 1,
          },
          1280: {
            slidesPerView: 1,
          },
        },
      };
      
    }
    ngOnChanges(changes: SimpleChanges) {
      if (changes['shipMethod'] && this.shipMethod === 'subscribe') {
        this.autoshipFreq = this.commonData.FrequencyTypes[0]?.ID; 
      }
    }
    openVideoModal() {
      this.isVideoModalOpen = true;
    }
  
    closeVideoModal() {
      this.isVideoModalOpen = false;
    }
  
    sideBarOpen(isAutoship,loyaltyOrder?:boolean){
      if(isAutoship){
        this.cartservice.addToCart(this.product,true, "", true, false, false, true,null,null,loyaltyOrder);
      }
      else{
        this.cartservice.addToCart(this.product,true, "", false, false, false, true,null,null,loyaltyOrder);
      }
      sessionStorage.setItem("params.item", JSON.stringify(this.product));
      this.SideNavBarService.openSidePanel();
    }
  }
